import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import User from "@/models/security/user.model";
import BaseApi from "@/core/HttpResources/BaseApi";
import UserRole from "@/models/security/userRole.model";
import Role from "@/models/security/role.model";
import { PermissionValue } from "@/enums/PermissionValue";
import { PermissionAccessLevel } from "@/enums/PermissionAccessLevel";
import PermissionAccess from '@/models/security/permissionAccess.model';
import UserResearchCenter from '@/models/security/userResearchCenter.Model';
import UserBasicInformation from '@/models/security/user-basic-information.model';

export default class UserService {


  async dontShowCreateResumeUserAgain(userId: number) {
    var baseApi = new BaseApi("user/DontShowCreateResumeUserAgain/" + userId);
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "PUT",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async createIfNoExist(user: UserBasicInformation) {
    var baseApi = new BaseApi("User/CreateIfNoExist");
    return new Promise<Array<any>>((resolve, reject) => {
      return baseApi.request(
        "POST",
        String(),
        user,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    }

    );
  }

  async getPendingEvaluationsByUser(userId: number): Promise<Array<any>> {
    var baseApi = new BaseApi("Porposal/getPendingEvaluationsByUser/" + userId);
    return new Promise<Array<any>>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async getUserRoles(userId: number): Promise<Array<Role>> {
    var baseApi = new BaseApi("user/" + userId + "/roles");
    return new Promise<Array<Role>>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  async getUserPermissionsGroupedByCategory(
    userId: number
  ): Promise<Array<any>> {
    var baseApi = new BaseApi("user/" + userId + "/permissions/group/category");
    return new Promise<Array<any>>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async attachRolToUser(userRole: UserRole): Promise<Array<any>> {
    var baseApi = new BaseApi("user/attach/role");
    return new Promise<Array<any>>((resolve, reject) =>
      baseApi.request(
        "POST",
        String(),
        userRole,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  async quitRolToUser(rolId: number): Promise<Array<any>> {
    var baseApi = new BaseApi("user/quit/role/" + rolId);
    return new Promise<Array<any>>((resolve, reject) =>
      baseApi.request(
        "DELETE",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  async researchCenterByUser(userId: number) {
    var baseApi = new BaseApi("user/ResearchCenterByUser/" + userId);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  async researchCenterByInvestigator(userId: number) {
    var baseApi = new BaseApi("user/ResearchCenterByInvestigator/" + userId);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  
  async GetInvestigatorRol(userId: number) {
    var baseApi = new BaseApi("user/GetInvestigatorRol/" + userId);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async getInvestigator() {
    var baseApi = new BaseApi("user/GetAllInvestigador");
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  getAllUser() {
    var baseApi = new BaseApi("user/GetAll");
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  async getUserById(userId: number) {
    var baseApi = new BaseApi("user/" + userId);
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  async getSimpleUserById(userId: number) {
    var baseApi = new BaseApi("user/simple/" + userId);
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  async getUserWithCVInfoById(userId: number) {
    var baseApi = new BaseApi("user/cv/" + userId);
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }


  getUserWithPermisions(userId: number) {
    var baseApi = new BaseApi("user/GetUserWithPermisions/" + userId);
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  async getUserByCriteria(criteria: string) {
    var baseApi = new BaseApi("user/GetUserByCriteria/" + criteria);
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async getUserByEmail(email: string) {
    var baseApi = new BaseApi("user/GetUserByEmail/" + email);
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async getUserIdByEmail(email: string) {
    var baseApi = new BaseApi("user/GetUserIdByEmail/" + email);
    return new Promise<number>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async updateUser(user: User) {
    var baseApi = new BaseApi("user/" + user.id);
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "PUT",
        String(),
        user,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  async disable(userId: number) {
    var baseApi = new BaseApi("user/disable/" + userId);
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "PUT",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async enable(userId: number) {
    var baseApi = new BaseApi("user/enable/" + userId);
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "PUT",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async saveCurriculum(user: User) {
    var baseApi = new BaseApi("user/SaveCurriculum/" + user.id);
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "PUT",
        String(),
        user,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async updateCVBlock(user: any, blockUrl: string) {
    var baseApi = new BaseApi("user/"+blockUrl+"/" + user.id);
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "PUT",
        String(),
        user,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }
  

  async updateUserPassword(changePassword: any) {
    var baseApi = new BaseApi("user/changePassword");
    return new Promise<User>((resolve, reject) =>
      baseApi.request(
        "PUT",
        String(),
        changePassword,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  getPermissionAccessLevel(permissionValue: PermissionValue): PermissionAccess {
    var user = JSON.parse(localStorage.getItem("user") || "{}") as User;

    var permission = user.permissions.filter(permission => {
      return permission.permissionValue == permissionValue;
    })[0];

    var permissionAccessLevel: PermissionAccess = new PermissionAccess();
    permissionAccessLevel.managment = false;
    permissionAccessLevel.view = false;
    permissionAccessLevel.write = false;

    if (user.isAdmin) {
      permissionAccessLevel.managment = permissionAccessLevel.view = permissionAccessLevel.write = true;
    } else if (permission) {
      switch (permission.permissionAccessLevel) {
        case PermissionAccessLevel.VIEW:
          permissionAccessLevel.view = true;
          break;
        case PermissionAccessLevel.EDIT:
          permissionAccessLevel.view = true;
          permissionAccessLevel.write = true;
          break;
        case PermissionAccessLevel.MANAGMENT:
          permissionAccessLevel.managment = true;
          permissionAccessLevel.write = true;
          permissionAccessLevel.view = true;
          break;
      }
    }

    return permissionAccessLevel;
  }

  hasPermission(permissionValue: PermissionValue): boolean {
    var user = JSON.parse(localStorage.getItem("user") || "{}") as User;
    var permission = user.permissions.some(permission => {
      return permission.permissionValue == permissionValue;
    });
    return permission;
  }

}
